'use es6';

import { selectFolder } from 'DesignData/actions/finder/Selections';
import { toggleOpenFolder, fetchContents } from 'DesignData/actions/finder/Folders';
import { toggleRenameAsset } from 'DesignData/actions/finder/Options';
import { FINDER_FOLDER_CREATE, FINDER_FOLDER_DUPLICATE, APPLICATION_EDITOR_LOADED, FINDER_FILE_DUPLICATE, FINDER_FILE_DUPLICATE_LAYOUT_TO_TEMPLATE } from 'DesignData/actions/ActionTypes';
let lastClonedFileId = null;
export default (({
  dispatch
}) => next => action => {
  const result = next(action);

  switch (result.type) {
    case FINDER_FOLDER_CREATE:
      {
        const {
          folder
        } = result;

        if (folder) {
          dispatch(toggleOpenFolder(folder.parentFolderId, true));
          dispatch(toggleOpenFolder(folder.id, true));
          dispatch(selectFolder(folder.id));
        }

        break;
      }

    case FINDER_FOLDER_DUPLICATE:
      {
        const {
          folder,
          files,
          subfolders,
          folderMetadata
        } = result;

        if (folder) {
          dispatch(fetchContents.receive({
            folder,
            files,
            subfolders,
            folderMetadata
          }));
          dispatch(toggleRenameAsset(folder.id, true));
          dispatch(toggleOpenFolder(folder.id, true));
          dispatch(selectFolder(folder.id));
        }

        break;
      }

    case FINDER_FILE_DUPLICATE_LAYOUT_TO_TEMPLATE:
    case FINDER_FILE_DUPLICATE:
      {
        const {
          file
        } = action;
        if (!file) break;
        lastClonedFileId = file.id;
        break;
      }

    case APPLICATION_EDITOR_LOADED:
      {
        const {
          fileId
        } = action;

        if (!fileId || !lastClonedFileId) {
          break;
        }

        if (fileId === lastClonedFileId) {
          dispatch(toggleRenameAsset(fileId, true));
          lastClonedFileId = null;
        }

        break;
      }

    default:
      break;
  }

  return result;
});